import { BRAZIL_STATES_OPTIONS } from './filterSchemas.constants'

export const benefitsEventsFilter = [
  {
    key: 'benefits-events-filter',
    title: 'Informações do evento',
    filters: [
      {
        key: 'region',
        type: 'select',
        options: BRAZIL_STATES_OPTIONS
      },
      {
        key: 'tag',
        type: 'select',
        options: [
          { label: 'Tipo', value: '' },
          { label: 'Visita à fábrica', value: 'FACTORY_VISIT' },
          { label: 'Evento exclusivo', value: 'EXCLUSIVE_EVENTS' }
        ]
      },
      {
        key: 'status',
        type: 'select',
        options: [
          { label: 'Situação', value: '' },
          { label: 'Ativo', value: 'ACTIVE' },
          { label: 'Inativo', value: 'INACTIVE' },
          { label: 'Programado', value: 'PROGRAMMED' },
          { label: 'Finalizado', value: 'FINISHED' }
        ]
      }
    ]
  }
]
